import React from 'react';
import { useLocation } from 'react-router-dom';
import GoogleCalendarSvg from '../../assets/svg/googleCalendar.svg';

const GoogleCalendarCallback = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const message = query.get('message');

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div
        className="text-center bg-white p-5 rounded shadow"
        style={{ maxWidth: '400px', width: '100%' }}>
        <div className="mb-3">
          <img
            src={GoogleCalendarSvg}
            alt="GoogleCalendarSvg Logo"
            style={{ width: '40px', height: '40px' }}
          />
        </div>
        <h1 className="h4 mb-3">Google Calendar Integration Status</h1>
        <p className="text-muted mb-4">{message || 'Awaiting response...'}</p>
        <button onClick={() => window.close()} className="btn btn-primary">
          Close Window
        </button>
      </div>
    </div>
  );
};

export default GoogleCalendarCallback;
